import loadingTruck from "../../Artifacts/Loading-truck.gif";
import loadingBg from "../../Artifacts/loader-bg.jpg";

const Loader = () => {
  return (
    <div className="relative flex justify-center items-center h-screen w-full">
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${loadingBg})`,
          opacity: 0.2,
        }}
      ></div>
      <img
        src={loadingTruck}
        loading="lazy"
        alt="Loading..."
        className="w-48 z-10"
      />
    </div>
  );
};

export default Loader;
